import { useCreateUtilityMutation } from "../../api/api-hooks";
import { UtilitiesForm } from "./utilitiesTypes";

const useUtilitiesCreator = () => {
  const [createUtil] = useCreateUtilityMutation();
  return (item: UtilitiesForm) => {
    if (!item.name || !item.link)
      return { error: { data: { message: "Missing required fields" } } };
    return createUtil({
      createUtilityDto: {
        name: item.name,
        link: item.link,
      },
    });
  };
};

export default useUtilitiesCreator;
